
//通用
import { Data as AuthContent } from '../authentication/index'
import { Data as ChangeLogContent } from '../changelog/index'
import { Data as OtherContent } from '../listenKey/index'

//共用
import { List as SocketContent } from '../spot/websocket/index'
import { Data as BasicContent } from '../spot/api/basic/index'

import { Data as AgentContent } from './api/agent/index'



let aaa = JSON.stringify(OtherContent)
aaa = aaa.replaceAll("/market/<listenKey>", "/market?listenKey==")
aaa = aaa.replaceAll("wss://open-api-ws.bingx.com/market?listenKey=", "wss://open-api-ws.bingx.com/market?listenKey=a8ea75681542e66f1a50a1616dd06ed77dab61baa0c296bca03a9b13ee5f2dd7")

const ROOT_MODULE = "en-us/agent"
import { Data as QandAContent } from '../q&a/index'
const QandA = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/q&a`,
  "name": "Frequently Asked Questions",
  "content": QandAContent
}

const ChangeLog = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/changelog`,
  "name": "Change Log",
  "content": ChangeLogContent
}

const Authentication = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication.html`,
  "name": "Authentication",
  "content": AuthContent
}
const Basic = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/base-info.html`,
  "name": "General Info",
  "content": BasicContent
}

const Permission = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/agent-interface.html`,
  "name": "Agent",
  "content": AgentContent
}


const Auth = {
  "module": ROOT_MODULE,
  "path": `/${ROOT_MODULE}/authentication-interface.html`,
  "name": "Authentication Interface",
  "content": JSON.parse(aaa)
}


export const agentConfig = [
  ChangeLog,
  QandA,
  Basic,
  Authentication,
  Permission,
]


// WEBPACK FOOTER //
// ./src/config/en-US/agent/index.js